<template>
  <WizardStep
    v-if="hasEditMerchantSettingsPermission"
    @submit="submit"
    @reset="reset"
  >
    <template v-slot:content>
      <div class="row">
        <div class="col-xl-6">
          <div class="form-group p-button-settings-container">
            <label>Order Number ID</label>
            <b-form-input
              type="text"
              class="form-control"
              v-model.trim="$v.idConfig.orderNumberId.$model"
              :state="validateState('orderNumberId')"
              placeholder="Order Number ID"
            />
            <div
              v-if="$v.idConfig.orderNumberId.$error"
              class="red--text font-italic"
            >
              Order Number ID is required
            </div>
          </div>

          <div class="form-group p-button-settings-container">
            <label>Amount ID</label>
            <b-form-input
              type="text"
              class="form-control"
              v-model.trim="$v.idConfig.amountId.$model"
              :state="validateState('amountId')"
              placeholder="Amount ID"
            />
            <div
              v-if="$v.idConfig.amountId.$error"
              class="red--text font-italic"
            >
              Amount ID is required
            </div>
          </div>

          <div class="form-group p-button-settings-container">
            <label>Button ID</label>
            <b-form-input
              type="text"
              class="form-control"
              v-model.trim="$v.idConfig.buttonId.$model"
              :state="validateState('buttonId')"
              placeholder="Button ID"
            />
            <div
              v-if="$v.idConfig.buttonId.$error"
              class="red--text font-italic"
            >
              Button ID is required
            </div>
          </div>
        </div>
      </div>
    </template>
  </WizardStep>
</template>

<script>
import WizardStep from "@/components/wizard/WizardStep";
import { required } from "vuelidate/lib/validators";
import MerchantSettingsPermissionsMixin from "@/components/merchantsettings/MerchantSettingsPermissionsMixin.js";

export default {
  mixins: [MerchantSettingsPermissionsMixin],
  components: { WizardStep },
  props: ["heading"],
  data: () => {
    return {
      idConfig: {
        orderNumberId: null,
        amountId: null,
        buttonId: null
      }
    };
  },
  validations: {
    idConfig: {
      orderNumberId: {
        required
      },
      amountId: {
        required
      },
      buttonId: {
        required
      }
    }
  },
  methods: {
    async submit() {
      if (!this.isMerchantAdmin) return;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        // do your submit logic here
        this.submitStatus = "PENDING";
        alert(`Pretending to set configurations:
        Order Number ID- ${this.idConfig.orderNumberId}
        Amount ID- ${this.idConfig.amountId}
        Button ID- ${this.idConfig.buttonId}`);
        setTimeout(() => {
          this.submitStatus = "OK";
        }, 500);
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.idConfig[name];
      return $dirty ? !$error : null;
    },

    reset() {
      this.idConfig.orderNumberId = null;
      this.idConfig.amountId = null;
      this.idConfig.buttonId = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-button-settings-container > label {
  clear: both;
  float: left;
  font-weight: 500 !important;
  font-size: 14px !important;
}
.p-button-settings-container {
  display: grid !important;
  grid-template-columns: 2fr 2fr !important;
}

@media only screen and (max-width: 1024px) {
  .p-button-settings-container > label {
    clear: none;
    float: none;
    font-weight: 500 !important;
    font-size: 14px !important;
  }
  .p-button-settings-container {
    display: flex !important;
    flex-direction: column;
  }
}
</style>
